if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.ppr_base_prod = false;
        this.parent_doc_app_container;
        this.document_app_el;
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;

        if (
          this.ppr_base_prod &&
          this.parent_doc_app_container &&
          this.document_app_el
        ) {
          //readd main product ppr

          this.parent_doc_app_container.appendChild(this.document_app_el);
          this.variant_el.reinitApps(document.querySelector('.product'));
        }
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        this.classList.add('loading');
        opener
          .querySelector('.loading-overlay__spinner')
          .classList.remove('hidden');
        this.loadContent(opener.getAttribute('data-product-url'), opener);
      }

      loadContent(url, opener = false) {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html',
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]',
            );

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            if (opener) {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              opener
                .querySelector('.loading-overlay__spinner')
                .classList.add('hidden');
            }
            this.classList.remove('loading');

            //reset app
            this.variant_el = this.querySelector(
              'variant-radios, variant-selects',
            );
            if (
              this.variant_el &&
              typeof this.variant_el.reinitApps == 'function'
            ) {
              this.variant_el.reinitApps(this);
            }
          });
      }

      setInnerHTML(element, html) {
        console.log(html);
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML),
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        this.modalContent
          .querySelector('variant-radios,variant-selects')
          .setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          'pickup-availability',
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`,
          );
        this.productElement
          .querySelectorAll('variant-selects, variant-radios')
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]',
        );
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute('role', 'presentation'));
      }
    },
  );
}
